<template>
  <div>
    <div
      v-for="catalog in catalogs"
      :key="catalog.id"
      class="d-flex align-items-center py-2 border-bottom"
      :class="{
        selected: enabledCatalogs[catalog.id],
      }"
    >
      <Checkbox
        :value="enabledCatalogs[catalog.id]"
        @update:value="$set(enabledCatalogs, catalog.id, $event); emit()"
      />
      <div
        class="flex-grow-1"
      >
        {{ catalog.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Checkbox from '../utils/Checkbox';

export default {
  props: {
    selected: Array,
  },
  data: () => ({
    enabledCatalogs: {},
    pending: false,
  }),
  components: {
    Checkbox,
  },
  computed: {
    ...mapGetters('shop', ['catalogs']),
  },
  watch: {
    selected(v) {
      this.enabledCatalogs = {};
      (v || []).forEach((x) => {
        if (this.catalogs.some((c) => c.id === x)) {
          this.$set(this.enabledCatalogs, x, true);
        }
      });
    },
  },
  methods: {
    emit() {
      const list = Object.entries(this.enabledCatalogs)
        .filter((e) => e[1])
        .map(([k]) => k);

      this.$emit('update:selected', list);
    },
  },
  created() {
    (this.selected || []).forEach((x) => {
      if (this.catalogs.some((c) => c.id === x)) {
        this.$set(this.enabledCatalogs, x, true);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.category-select {
  border: 2px solid #eee;
  border-radius: 10px;
  padding: 3px 10px;
  margin-top: 5px;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: rgba(#aaa, 0.1);
    border-color: #aaa;
  }

  &.readonly {
    cursor: default;
  }
  &.readonly:hover {
    background-color: #fff;
    border: 2px solid #eee;
  }
}
</style>
